import { FoodsIcon, Typography as FoodsTypography } from "@foodpilot/foods";
import { Box, Stack, Typography as MuiTypography, useTheme } from "@mui/material";
import { Link } from "react-router";
import type { ComponentAppearance } from "src/components/appearance";

type Props = {
    to: string;
    label: ReactNode;
    inNewTab?: boolean;
    appearance?: ComponentAppearance;
};

export const GridLink = (props: Props) => {
    const { to, label, inNewTab = false, appearance = "legacy" } = props;
    const theme = useTheme();
    const isProductUxV2 = appearance === "product-v2";
    const Typography = isProductUxV2 ? FoodsTypography : MuiTypography;

    const title = typeof label === "string" ? label : undefined;
    return (
        <Link
            to={to}
            target={inNewTab ? "_blank" : undefined}
            style={{
                textDecoration: "none",
            }}
        >
            <Stack
                flexDirection={"row"}
                alignItems={"center"}
                gap={theme.spacing(1)}
                sx={{
                    color: theme.palette.primary[600],
                }}
            >
                <Typography
                    variant="body-bold"
                    // This is important because Grid automatically reduces lines for <p> tag
                    component={"p"}
                    title={title}
                    sx={{
                        color: theme.palette.primary[600],
                    }}
                >
                    {label}
                </Typography>
                {inNewTab && (
                    <Box>
                        <FoodsIcon size={2} icon={"openNewTab"} />
                    </Box>
                )}
            </Stack>
        </Link>
    );
};
